import angular from 'angular';
import ComponentsModule from '../components-module';
import template from './code-content-structure.html';

const COMPONENT_NAME = 'codeContentStructure';

angular.module (ComponentsModule)
  .component (COMPONENT_NAME, {
    template,
    bindings: {},

    controller: ($scope, $timeout, ApplicationConfigurationService) => {
      let ctrl = $scope.$ctrl;
      ctrl.minimized = false;

      ctrl.loadConf = () => {
        ApplicationConfigurationService.getConfigurationsFor(['ContentStructure'])
          .then(([contentStructureConfig]) => {
            $timeout(() => {
              ctrl.structureTreeConfig = Object.assign({ enabled: true }, contentStructureConfig);
              ctrl.enabled = ctrl.structureTreeConfig.enabled
                && (ctrl.structureTreeConfig.structureRoots || []).length > 0;
            });
          })
          .catch (() => {
            ctrl.structureTreeConfig = undefined;
            ctrl.enabled = false;
          });
      };

      $scope.$on('aceui:userLoggedOut', () => {
        ctrl.structureTreeConfig = undefined;
      });

      $scope.$on('aceui:authenticationSuccess', () => {
        ctrl.loadConf();
      });

      ctrl.$onInit = () => {
        ctrl.loadConf();
      };
    }
  });

export default COMPONENT_NAME;
